import './PriceHistoryCard.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import { CurrencyEnum } from '@search/graphql-typings';
import { formatPrice } from '@search/helpers/src/gql/formatPrice';
import classname from '@search/classname/src';
import Grid from '@vtblife/uikit-grid';

import { PriceHistoryPart } from './PriceHistoryPart';
import { PriceHistoryDiff } from './PriceHistoryDiff';

const cn = classname.bind(null, 'PriceHistoryCard');

export function PriceHistoryCard({
    item,
    spaced = false
}: {
    spaced?: boolean;
    item: PriceHistoryPart;
}) {
    const date = item.date2?.formattedFull;
    const price = formatPrice({
        value: item.valueRub,
        currency: CurrencyEnum.Rub,
        displayCurrency: true,
        noFractional: true
    });
    const diff = item.diff?.rub && <PriceHistoryDiff diff={item.diff.rub} />;

    if (spaced) {
        return (<div className={cn(null, { spaced })}>
            {date}
            <div className={cn('price-diff-wrapper')}>
                {price}
                {diff && <Typography
                    variant='small-alone'
                    className={cn('price-diff')}
                >{diff}</Typography>}
            </div>
        </div>);
    }

    return (<Grid cols={12}>
        <Grid.Cell m={4}>
            <div className={cn('cell')}>{date}</div>
        </Grid.Cell>
        <Grid.Cell m={4}>
            <div className={cn('cell')}>{price}</div>
        </Grid.Cell>
        <Grid.Cell m={4}>
            <div className={cn('cell', { right: true })}>{diff}</div>
        </Grid.Cell>
    </Grid>);
}
